"use strict";

angular.module('app')
    .service('Coupons', function (Request) {
        var coupons = {};

        coupons.get = function () {
            return Request.get('coupons/').then(function (res) {
                return res.data;
            });
        };

        coupons.set = function (data) {
            return Request.post('coupons/', data).then(function (res) {
                return res.data;
            });
        };

        coupons.del = function (id) {
            return Request.del('coupons/' + id + '/').then(function (res) {
                return res.data;
            });
        };

        return coupons;

    });